import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import EstructOrganizativa from "./estructuraOrganizativa";
import CambiarEfiscal from "./modalCambiarEfiscal";
import { CambiarFechaSis } from "./modalFechaSistema";
import { Toasts } from "../toasts";

import { Organizacion } from "./organizacion";
import TablaPersonas from "./personas";
import TasasPasiva from "./tasaPasiva";
import TasasActivas from "./tasasActivas";
import UnidadContable from "./unidadContable";
import UnidadTributaria from "./unidadTributaria";
import TablaUsuarios from "./usuarios";
import ValorPetro from "./valorPetro";
import bcv from "../../imagenes/bcv.png";
import GenerarBackup from "./generarBackud";
import { TimbreActu } from "./TimbreActu";
import { ValorIva } from "./modalValorIva";
import TablaImpresoras from './impresoras';
// import { height } from '@mui/system';
/* import bcv from '../../imagenes/'

import { Personas } from './configuracionGeneral/personas';
import { Usuario } from './configuracionGeneral/usuarios';
import { Petro } from './configuracionGeneral/valorpetro';
import { UTE } from './configuracionGeneral/valorute';
import { UsuarioWeb } from './configuracionGeneral/usuariosWeb';
import { UsuariosApp } from './configuracionGeneral/usuariosApp';
import { PorcentajeUTE } from './configuracionGeneral/valoruteporcentaje';
import EstructOrganizativa from './configuracionGeneral/tablaPestructuraOrg';
import CambiarEfiscal from '../catalogos/catalogoCambiarEfiscal';
import { DolarBcv } from './configuracionGeneral/valordolarbcv';

 */
import axios from "axios";

export const VerConfiguracion = (props) => {
  let op = require("../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const [mostrar, setMostrar] = useState("");
  const [mostrarFecha, setMostrarFecha] = useState(false);
  const [mostrarIva, setMostrarIva] = useState(false);
  const [show, setShow] = useState(false);

  // const [clase, setClase] = useState('d-flex bluex-bg')
  // const [bloqueo, setBloqueo] = useState(false)
  const [msg1, setMsg1] = useState(52);
  // const [icon, setIcon] = useState();
  const [iva, setIva] = useState(0.0);
  const [accconfigene, setAccconfigene] = useState(
    /* JSON.parse(localStorage.getItem('accconfigene')) */ "11111111111111",
  );
  const acctasaactiva = JSON.parse(localStorage.getItem("acctasaactiva"));
  const acctasapasiva = JSON.parse(localStorage.getItem("acctasapasiva"));
  const acccambiofecha = JSON.parse(localStorage.getItem("acccambiofecha"));
  const acccambioefiscal = JSON.parse(localStorage.getItem("acccambioefiscal"));
  const accusuario = JSON.parse(localStorage.getItem("accusuario")) === null ? "0000" : JSON.parse(localStorage.getItem("accusuario")).trim();
  const accorganizacion = JSON.parse(localStorage.getItem("accorganizacion")) === null ? "0000" : JSON.parse(localStorage.getItem("accorganizacion")).trim();
  const accpersona = JSON.parse(localStorage.getItem("accpersona")) === null ? "0000" : JSON.parse(localStorage.getItem("accpersona")).trim();
  const accestructura = JSON.parse(localStorage.getItem("accestructura")) === null ? "0000" : JSON.parse(localStorage.getItem("accestructura")).trim();
  const accut = JSON.parse(localStorage.getItem("accut")) === null ? "0" : JSON.parse(localStorage.getItem("accut")).trim();
  const acciva = JSON.parse(localStorage.getItem("acciva")) === null ? "0" : JSON.parse(localStorage.getItem("acciva")).trim();
  const [toast, setToast] = useState({
    mostrar: false,
    mensaje: "",
    titulo: "",
  });

  const mostrarVis = (vista) => (e) => {
    e.preventDefault();
    let sigue = true;
    if (
      vista === 0 ||
      vista === 1 ||
      vista === 2 ||
      vista === 4 ||
      vista === 5 ||
      vista === 6 ||
      vista === 7 ||
      vista === 9 ||
      vista === 10 ||
      vista === 13
    ) {
      if (vista === 0 && accorganizacion.toString() === "0000") {
        sigue = false;
        setToast({
          mostrar: true,
          mensaje: "No posee permiso para este modulo.",
          titulo: "Alerta.",
        });
      } else if (vista === 1 && accpersona.toString() === "0000") {
        sigue = false;
        setToast({
          mostrar: true,
          mensaje: "No posee permiso para este modulo.",
          titulo: "Alerta.",
        });
      } else if (vista === 2 && accusuario.toString() === "0000") {
        sigue = false;
        setToast({
          mostrar: true,
          mensaje: "No posee permiso para este modulo.",
          titulo: "Alerta.",
        });
      } else if (vista === 4 && accut.toString() === "0") {
        sigue = false;
        setToast({
          mostrar: true,
          mensaje: "No posee permiso para este modulo.",
          titulo: "Alerta.",
        });
      } else if (vista === 5 && accestructura.toString() === "0000") {
        sigue = false;
        setToast({
          mostrar: true,
          mensaje: "No posee permiso para este modulo.",
          titulo: "Alerta.",
        });
      } else if (vista === 6 && acctasaactiva.toString() === "0") {
        sigue = false;
        setToast({
          mostrar: true,
          mensaje: "No posee permiso para este modulo.",
          titulo: "Alerta.",
        });
      } else if (vista === 7 && acctasapasiva.toString() === "0") {
        sigue = false;
        setToast({
          mostrar: true,
          mensaje: "No posee permiso para este modulo.",
          titulo: "Alerta.",
        });
      } else if (vista === 9 && acccambiofecha.toString() === "0") {
        sigue = false;
        setToast({
          mostrar: true,
          mensaje: "No posee permiso para este modulo.",
          titulo: "Alerta.",
        });
      } else if (vista === 10 && acccambioefiscal.toString() === "0") {
        sigue = false;
        setToast({
          mostrar: true,
          mensaje: "No posee permiso para este modulo.",
          titulo: "Alerta.",
        });
      } else if (vista === 13 && acciva.toString() === "0") {
        sigue = false;
        setToast({
          mostrar: true,
          mensaje: "No posee permiso para este modulo.",
          titulo: "Alerta.",
        });
      } else {
        sigue = true;
      }
    }
    if (sigue) {
      if (vista === 9) {
        setMostrarFecha(true);
      } else if (vista === 8) {
        setMsg1("Factor Valor de Cambio");
      } else if (vista === 10) {
        setShow(true);
      } else if (vista === 13) {
        setMostrarIva(true);
      }
      setMostrar(vista);
    }
  };
  const cancelar = () => {
    setMostrar("");
    // setClase('d-flex bluex-bg')
    props.onHideCancela();
  };
  const menuclick = (titulo) => (e) => {
    e.preventDefault();
    setMsg1(titulo);
    // if (clase === 'd-flex bluex-bg') {
    //     setClase('d-flex bluex-bg toggled');
    // } else {
    //     setClase('d-flex bluex-bg');
    // }
  };

  // const handleCancelara = () => {
  //     setMostrar1(false);
  // }

  // const catalogoEfiscal = (e) => {
  //     e.preventDefault();
  //     setMsg1("INICIO");
  //     setMostrar1(true);
  // };

  const cerrarToast = () => {
    setToast({
      ...toast,
      mostrar: false,
    });
  };
  // const SeleccionarEfiscal = (idefiscal, descrip, anio, statusorg, statuspresup, statuspuc, statuscat) => {
  //     setMostrar1(false);
  //     localStorage.setItem('idefiscal', idefiscal);
  //     localStorage.setItem('efiscaldes', descrip);
  //     localStorage.setItem('efiscalanio', anio);
  //     localStorage.setItem('efiseleccionado', true);
  //     localStorage.setItem('statuspresup', statuspresup);
  //     localStorage.setItem('statuspuc', statuspuc);
  //     localStorage.setItem('statuscat', statuscat);
  //     localStorage.setItem('statusorg', statusorg);
  // }

  const vista = {
    0: <Organizacion />,
    1: <TablaPersonas />,
    2: <TablaUsuarios />,
    3: <UnidadContable />,
    4: <UnidadTributaria />,
    5: <EstructOrganizativa />,
    6: <TasasActivas />,
    7: <TasasPasiva />,
    8: <ValorPetro />,
    11: <GenerarBackup />,
    12: <TimbreActu />,
    14: <TablaImpresoras />,
  };

  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header className="azulGradiant header-modal">
        <h3 className="text-light font-bold m-0">Configuración General</h3>
        <i className="far fa-window-close" onClick={cancelar}></i>
      </Modal.Header>
      <Modal.Body className="p-0">
        <div
          className="col-12 m-0 p-0 d-flex bluex-bg"
          id="wrapper"
          style={{ height: "70vh" }}
        >
          <ul
            className="col-2 m-0 p-0 amanecergris list-group list-group-light"
            style={{ height: "70vh", overflowY: "auto" }}
          >
            <li
              className="list-group-item px-0 p-0 btn-primary"
              onClick={menuclick("Organización")}
              style={{
                pointerEvents:
                  accconfigene && accconfigene.substring(0, 1) === "0"
                    ? "none"
                    : "cursor",
                color:
                  accconfigene && accconfigene.substring(0, 1) === "0"
                    ? "rgb(183, 183, 183)"
                    : "#1d0345",
                backgroundColor:
                  accconfigene && accconfigene.substring(0, 1) === "0"
                    ? "rgba(144, 143, 142, 0.76)"
                    : "transparent",
              }}
            >
              <a
                className="list-group-item list-group-item-action py-3 ripple bg-transparent px-1"
                type="button"
                onClick={mostrarVis(0)}
              >
                <i className="fas fa-sitemap fa-fw me-3 text-light px-2"></i>
                <span className="fw-bold text-uppercase fw-bold">
                  Organizacion
                </span>
              </a>
            </li>
            <li
              className="list-group-item px-0 p-0 btn-primary"
              onClick={menuclick("Modulo Personas")}
              style={{
                pointerEvents:
                  accconfigene && accconfigene.substring(1, 2) === "0"
                    ? "none"
                    : "cursor",
                color:
                  accconfigene && accconfigene.substring(1, 2) === "0"
                    ? "rgb(183, 183, 183)"
                    : "#1d0345",
                backgroundColor:
                  accconfigene && accconfigene.substring(1, 2) === "0"
                    ? "rgba(144, 143, 142, 0.76)"
                    : "transparent",
              }}
            >
              <a
                className="list-group-item list-group-item-action py-3 ripple bg-transparent px-1"
                type="button"
                onClick={mostrarVis(1)}
              >
                <i className="fas fa-user-alt fa-fw me-3 text-primary px-2" />
                <span className=" fw-bold">Personas</span>
              </a>
            </li>
            {accusuario !== "0000" ? (
              <li
                className="list-group-item px-0 p-0 btn-primary"
                onClick={menuclick("Modulo Usuarios")}
                style={{
                  pointerEvents:
                    accconfigene && accconfigene.substring(2, 3) === "0"
                      ? "none"
                      : "cursor",
                  color:
                    accconfigene && accconfigene.substring(2, 3) === "0"
                      ? "rgb(183, 183, 183)"
                      : "#1d0345",
                  backgroundColor:
                    accconfigene && accconfigene.substring(2, 3) === "0"
                      ? "rgba(144, 143, 142, 0.76)"
                      : "transparent",
                }}
              >
                <a
                  className="list-group-item list-group-item-action py-3 ripple bg-transparent px-1"
                  type="button"
                  onClick={mostrarVis(2)}
                >
                  <i className="fas fa-user-check fa-fw me-3 text-success px-2" />
                  <span className="fw-bold text-uppercase fw-bold">
                    Usuarios
                  </span>
                </a>
              </li>
            ) : (
              ""
            )}
            <li
              className="list-group-item px-0 p-0 btn-primary"
              onClick={menuclick("Unidad Contable")}
              style={{
                pointerEvents:
                  accconfigene && accconfigene.substring(3, 4) === "0"
                    ? "none"
                    : "cursor",
                color:
                  accconfigene && accconfigene.substring(3, 4) === "0"
                    ? "rgb(183, 183, 183)"
                    : "#1d0345",
                backgroundColor:
                  accconfigene && accconfigene.substring(3, 4) === "0"
                    ? "rgba(144, 143, 142, 0.76)"
                    : "transparent",
              }}
            >
              <a
                className="list-group-item list-group-item-action py-3 ripple bg-transparent px-1"
                type="button"
                onClick={mostrarVis(3)}
              >
                <i className="fas fa-university fa-fw me-3 text-info px-2" />
                <span className="fw-bold text-uppercase fw-bold">
                  Unidad Contable
                </span>
              </a>
            </li>
            <li
              className="list-group-item px-0 p-0 btn-primary"
              onClick={menuclick("Unidad Tributaria")}
              style={{
                pointerEvents:
                  accconfigene && accconfigene.substring(3, 4) === "0"
                    ? "none"
                    : "cursor0",
                color:
                  accconfigene && accconfigene.substring(3, 4) === "0"
                    ? "rgb(183, 183, 183)"
                    : "#1d0345",
                backgroundColor:
                  accconfigene && accconfigene.substring(3, 4) === "0"
                    ? "rgba(144, 143, 142, 0.76)"
                    : "transparent",
              }}
            >
              <a
                className="list-group-item list-group-item-action py-3 ripple bg-transparent px-1"
                type="button"
                onClick={mostrarVis(4)}
              >
                <i className="fas fa-university fa-fw me-3 text-info px-2" />
                <span className=" fw-bold">Unidad Tributaria</span>
              </a>
            </li>
            <li
              className="list-group-item px-0 p-0 btn-primary"
              onClick={menuclick("Estructura Organizativa")}
              style={{
                pointerEvents:
                  accconfigene && accconfigene.substring(4, 5) === "0"
                    ? "none"
                    : "cursor",
                color:
                  accconfigene && accconfigene.substring(4, 5) === "0"
                    ? "rgb(183, 183, 183)"
                    : "#1d0345",
                backgroundColor:
                  accconfigene && accconfigene.substring(4, 5) === "0"
                    ? "rgba(144, 143, 142, 0.76)"
                    : "transparent",
              }}
            >
              <a
                className="list-group-item list-group-item-action py-3 ripple bg-transparent px-1"
                type="button"
                onClick={mostrarVis(5)}
              >
                <i className="fas fa-chart-line fa-fw me-3 text-warning px-2" />
                <span className="fw-bold text-uppercase fw-bold">
                  Estructura Organizativa
                </span>
              </a>
            </li>
            <li
              className="list-group-item px-0 p-0 btn-primary"
              onClick={menuclick("Tasas Activas")}
              style={{
                pointerEvents:
                  accconfigene && accconfigene.substring(5, 6) === "0"
                    ? "none"
                    : "cursor",
                color:
                  accconfigene && accconfigene.substring(5, 6) === "0"
                    ? "rgb(183, 183, 183)"
                    : "#1d0345",
                backgroundColor:
                  accconfigene && accconfigene.substring(5, 6) === "0"
                    ? "rgba(144, 143, 142, 0.76)"
                    : "transparent",
              }}
            >
              <a
                className="list-group-item list-group-item-action py-3 ripple bg-transparent px-1"
                type="button"
                onClick={mostrarVis(6)}
              >
                <i className="fas fa-chart-line fa-fw me-3 text-primary px-2" />
                <span className="fw-bold text-uppercase fw-bold">
                  Tasas Activas
                </span>
              </a>
            </li>
            <li
              className="list-group-item px-0 p-0 btn-primary"
              onClick={menuclick("Tasas Pasivas")}
              style={{
                pointerEvents:
                  accconfigene && accconfigene.substring(6, 7) === "0"
                    ? "none"
                    : "cursor",
                color:
                  accconfigene && accconfigene.substring(6, 7) === "0"
                    ? "rgb(183, 183, 183)"
                    : "#1d0345",
                backgroundColor:
                  accconfigene && accconfigene.substring(6, 7) === "0"
                    ? "rgba(144, 143, 142, 0.76)"
                    : "transparent",
              }}
            >
              <a
                className="list-group-item list-group-item-action py-3 ripple bg-transparent px-1"
                type="button"
                onClick={mostrarVis(7)}
              >
                <i className="fas fa-users-cog fa-fw me-3 text-secondary px-2" />
                <span className="fw-bold text-uppercase fw-bold">
                  Tasas Pasivas
                </span>
              </a>
            </li>
            <li
              className="list-group-item px-0 p-0 btn-primary"
              onClick={menuclick("Valor % IVA")}
              style={{
                pointerEvents:
                  accconfigene && accconfigene.substring(5, 6) === "0"
                    ? "none"
                    : "cursor",
                color:
                  accconfigene && accconfigene.substring(5, 6) === "0"
                    ? "rgb(183, 183, 183)"
                    : "#1d0345",
                backgroundColor:
                  accconfigene && accconfigene.substring(5, 6) === "0"
                    ? "rgba(144, 143, 142, 0.76)"
                    : "transparent",
              }}
            >
              <a
                className="list-group-item list-group-item-action py-3 ripple bg-transparent px-1"
                type="button"
                onClick={mostrarVis(13)}
              >
                <i className="fas fa-chart-line fa-fw me-3 text-primary px-2" />
                <span className="fw-bold text-uppercase fw-bold">
                  Valor % IVA
                </span>
              </a>
            </li>
            <li
              className="list-group-item px-0 p-0 btn-primary"
              style={{
                pointerEvents:
                  accconfigene && accconfigene.substring(7, 8) === "0"
                    ? "none"
                    : "cursor",
                color:
                  accconfigene && accconfigene.substring(7, 8) === "0"
                    ? "rgb(183, 183, 183)"
                    : "#1d0345",
                backgroundColor:
                  accconfigene && accconfigene.substring(7, 8) === "0"
                    ? "rgba(144, 143, 142, 0.76)"
                    : "transparent",
              }}
            >
              <a
                className="list-group-item list-group-item-action py-3 ripple bg-transparent px-1"
                type="button"
                onClick={mostrarVis(8)}
              >
                <img
                  className="img-fluid my-auto mx-auto"
                  style={{ height: 20 }}
                  src={bcv}
                />
                <span className="fw-bold text-uppercase fw-bold">
                  Factor Valor de Cambio
                </span>
              </a>
            </li>
            <li
              className="list-group-item px-0 p-0 btn-primary"
              style={{
                pointerEvents:
                  accconfigene && accconfigene.substring(8, 9) === "0"
                    ? "none"
                    : "cursor",
                color:
                  accconfigene && accconfigene.substring(8, 9) === "0"
                    ? "rgb(183, 183, 183)"
                    : "#1d0345",
                backgroundColor:
                  accconfigene && accconfigene.substring(8, 9) === "0"
                    ? "rgba(144, 143, 142, 0.76)"
                    : "transparent",
              }}
            >
              <a
                className="list-group-item list-group-item-action py-3 ripple bg-transparent px-1"
                type="button"
                onClick={mostrarVis(9)}
              >
                <i className="fas fa-users-cog fa-fw me-3 text-primary px-2" />
                <span className="fw-bold text-uppercase fw-bold">
                  Fecha Sistema
                </span>
              </a>
            </li>
            <li
              className="list-group-item px-0 p-0 btn-primary"
              style={{
                pointerEvents:
                  accconfigene && accconfigene.substring(9, 10) === "0"
                    ? "none"
                    : "cursor",
                color:
                  accconfigene && accconfigene.substring(9, 10) === "0"
                    ? "rgb(183, 183, 183)"
                    : "#1d0345",
                backgroundColor:
                  accconfigene && accconfigene.substring(9, 10) === "0"
                    ? "rgba(144, 143, 142, 0.76)"
                    : "transparent",
              }}
            >
              <a
                className="list-group-item list-group-item-action py-3 ripple bg-transparent px-1"
                type="button"
                onClick={mostrarVis(10)}
              >
                <i className="fas fa-tags fa-fw me-3 redlater-text px-2" />
                <span className=" fw-bold">Cambiar Ejercicio Fiscal</span>
              </a>
            </li>
            <li
              className="list-group-item px-0 p-0 btn-primary"
              style={{
                pointerEvents:
                  accconfigene && accconfigene.substring(9, 10) === "0"
                    ? "none"
                    : "cursor",
                color:
                  accconfigene && accconfigene.substring(9, 10) === "0"
                    ? "rgb(183, 183, 183)"
                    : "#1d0345",
                backgroundColor:
                  accconfigene && accconfigene.substring(9, 10) === "0"
                    ? "rgba(144, 143, 142, 0.76)"
                    : "transparent",
              }}
            >
              <a
                className="list-group-item list-group-item-action py-3 ripple bg-transparent px-1"
                type="button"
                onClick={mostrarVis(11)}
              >
                <i className="  fas fa-database fa-fw me-3 text-danger px-2 fa-fw me-3 redlater-text px-2" />
                <span className=" fw-bold">Respaldar DB</span>
              </a>
            </li>
            <li
              className="list-group-item px-0 p-0 btn-primary"
              style={{
                pointerEvents:
                  accconfigene && accconfigene.substring(9, 10) === "0"
                    ? "none"
                    : "cursor",
                color:
                  accconfigene && accconfigene.substring(9, 10) === "0"
                    ? "rgb(183, 183, 183)"
                    : "#1d0345",
                backgroundColor:
                  accconfigene && accconfigene.substring(9, 10) === "0"
                    ? "rgba(144, 143, 142, 0.76)"
                    : "transparent",
              }}
            >
              <a
                className="list-group-item list-group-item-action py-3 ripple bg-transparent px-1"
                type="button"
                onClick={mostrarVis(12)}
              >
                <i className="fas fa-sync-alt fa-fw me-3 text-danger px-2 fa-fw me-3 redlater-text px-2" />
                <span className=" fw-bold">Sincronizar</span>
              </a>
            </li>
            <li className="list-group-item px-0 p-0 btn-primary"
              style={{
                pointerEvents: accconfigene && accconfigene.substring(9, 10) === '0' ? 'none' : 'cursor',
                color: accconfigene && accconfigene.substring(9, 10) === '0' ? 'rgb(183, 183, 183)' : '#1d0345',
                backgroundColor: accconfigene && accconfigene.substring(9, 10) === '0' ? 'rgba(144, 143, 142, 0.76)' : 'transparent'
              }}>
              <a className="list-group-item list-group-item-action py-3 ripple bg-transparent px-1"
                type="button"
                onClick={mostrarVis(14)}>
                <i className="fas fa-print fa-fw me-3 text-primary px-2 fa-fw me-3 redlater-text px-2" /><span className=' fw-bold'>
                  Impresoras
                </span>
              </a>
            </li>
            <li
              className="list-group-item px-0 p-0 bg-transparent"
              style={{ color: "#1d0345" }}
            >
              <a
                className="list-group-item list-group-item-action py-3 ripple bg-transparent px-1"
                type="button"
                onClick={cancelar}
              >
                <i className="fas fa-power-off fa-fw me-3 text-danger px-2" />
                <span className="fw-bold text-uppercase fw-bold">Salir</span>
              </a>
            </li>
          </ul>
          <div
            className="col-10 m-0 p-0"
            style={{ height: "70vh", overflowY: "auto" }}
          >
            {vista[mostrar]}
          </div>
        </div>
        <CambiarFechaSis
          show={mostrarFecha}
          onHide={() => {
            setMostrarFecha(false);
          }}
        />

        <ValorIva
          show={mostrarIva}
          onHide={() => {
            setMostrarIva(false);
          }}
          valor={iva}
        />

        <CambiarEfiscal show={show} setShow={setShow} />

        <Toasts
          show={toast.mostrar}
          titulo={toast.titulo}
          mensaje={toast.mensaje}
          onHideCancela={cerrarToast}
        />
      </Modal.Body>
    </Modal>
  );
};
